export const ProgressivePermissions = {
  ReadPermission: "machines.progressives.read",
  EditPermission: "machines.progressives.write",
  SensitiveInfoPermission: "machines.progressives.sensitiveInfo",
  AccountingReportsPermission: "machines.progressives.accountingReports",
};
